import { Store } from 'redux';
import { isBrowser, isExplorer } from 'utils';
import { addToCart, addItemsToCart, addSampleToCart } from 'components/Cart/actions';
import { getList } from 'components/Compare/actions';
import { basketToggle } from 'components/Basket/actions';
import { AddItemRequest } from 'models/AddItemRequest';
import { AddSampleItemRequest } from 'models/AddSampleItemRequest';
import { ThunkDispatch } from './connect';

/* eslint-disable */
// Legacy application hooks

interface CartItemResponse {
  Success: boolean;
  Message: string;
}

const splitConfiguratorVariabled = (conf: any): { [key: string]: string } | undefined =>
  (conf &&
    conf.split(';').reduce((acc: { [key: string]: string }, item: string) => {
      const kvp = item.split('=');
      acc[kvp[0]] = kvp[1];
      return acc;
    }, {})) ||
  undefined;

const hooks = (dispatch: ThunkDispatch, Deferred: () => any) => ({
  reloadCompareList: () => {
    dispatch(getList());
  },

  getCompareList: () => {
    dispatch(getList());
  },

  toggleMiniBasket: () => {
    dispatch(basketToggle());
  },

  addSampleToCart(data: AddSampleItemRequest) {
    const d = Deferred();
    dispatch(addSampleToCart(data))
      .then(res =>
        d.resolve({
          AddedProduct: res.addedProduct,
          Success: res.success,
          Message: res.message
        } as CartItemResponse)
      )
      .catch(d.reject);
    return d.promise();
  },

  addToCart(data: AddItemRequest) {
    data.configuratorVariables = splitConfiguratorVariabled(data.configuratorVariables);
    data.addonProducts = data.addonProducts || [];
    const d = Deferred();
    dispatch(addToCart({ input: data }))
      .then(res =>
        d.resolve({
          AddedProduct: res.addedProduct,
          Success: res.success,
          Message: res.message
        } as CartItemResponse)
      )
      .catch(d.reject);
    return d.promise();
  },

  addItemsToCart(data: AddItemRequest[]) {
    data = data.map(d => (d.addonProducts ? d : { ...d, addonProducts: [] }));
    const d = Deferred();
    dispatch(addItemsToCart(data))
      .then(res =>
        d.resolve({
          AddedProduct: res.addedProduct,
          Success: res.success,
          Message: res.message
        } as CartItemResponse)
      )
      .catch(d.reject);
    return d.promise();
  }
});

export function applyStoreEvents<S>(store: Store<S>) {
  if (!isBrowser()) {
    return;
  }

  window.addEventListener(REDUX_EVENT, ({ detail }: CustomEvent) => {
    store.dispatch(detail);
  });

  if ((window as any).jQuery) {
    (window as any).hooks = hooks(store.dispatch, (window as any).jQuery.Deferred);
  }
}

const REDUX_EVENT = 'redux:event';
// Emits response to apps
export const reduxDispatchEvent = (resp: {}) => {
  const evt = isExplorer() ? ieEvent(resp) : new CustomEvent(REDUX_EVENT, { detail: resp });
  return new Promise(resolve => {
    window.dispatchEvent(evt);
    resolve(resp);
  });
};

declare global {
  interface Window {
    reduxDispatchEvent: (resp: {}) => Promise<unknown>;
  }
}

// Expose the reduxDispatcher, so it can be used everywhere
if (isBrowser()) {
  if (window) {
    window.reduxDispatchEvent = reduxDispatchEvent;
  }
}

function ieEvent(resp: {}) {
  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(REDUX_EVENT, false, false, resp);
  return evt;
}
